document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.region-button').addEventListener('click', function() {
      const select = document.querySelector('.region-dropdown');
      const selectedOption = select.options[select.selectedIndex]; 
      // alert(`Region: ${selectedOption.text}\nURL: ${select.value}\n\nRedirecting now...`);
      window.location.href = select.value;
  });
});